export const NAVIGATE = {
    DIRECT_CALL: "direct_call",
    MASKED_CALL: "number_mask",
    VIEW_JOB: "view_job",
    SEND_WHATSAPP: "send_whatsapp",
}
export const NAVIGATE_TYPE = {
    [NAVIGATE.DIRECT_CALL]: "call_hr",
    [NAVIGATE.MASKED_CALL]: "masked_call",
    [NAVIGATE.VIEW_JOB]: "view_job",
    [NAVIGATE.SEND_WHATSAPP]: "send_whatsapp",
}
